export class AssetType {
  static png = "PNG";
  static jpg = "JPG";
  static gif = "GIF";
  static svg = "SVG";
  static pdf = "PDF";
  static eps = "EPS";
  static tiff = "TIFF";
  static color = "COLOR";
  static URL = "URL";
  static textStyle = "TEXT_STYLE";
  static sketchLayer = "SKETCH_LAYER";
  static sketchSymbol = "SKETCH_SYMBOL";
  static sketchLayerStyle = "SKETCH_LAYER_STYLE";
  static sketchTextStyle = "SKETCH_TEXT_STYLE";
  // Motion
  static mov = "MOV";
  static mp4 = "MP4";
  static lottie = "LOTTIE";
  // Audio
  static wav = "WAV";
  static flac = "FLAC";
  static m4a = "M4A";
  static mp3 = "MP3";
  static ogg = "OGG";
  // Generic
  static ai = "AI";
  static txt = "TXT";
  static docx = "DOCX";
  static dotx = "DOTX";
  static indd = "INDD";
  static keynoteTheme = "KEYNOTE_THEME";
  static keynote = "KEYNOTE";
  static pagesTemplate = "PAGES_TEMPLATE";
  static pages = "PAGES";
  static potx = "POTX";
  static pptx = "PPTX";
  static psd = "PSD";
  static zip = "ZIP";
  // 3D Models
  static obj = "OBJ";
  static stl = "STL";

  static imageTypes = new Set([
    AssetType.png,
    AssetType.jpg,
    AssetType.gif,
    AssetType.svg,
    AssetType.pdf,
    AssetType.eps,
    AssetType.tiff,
  ]);

  static genericTypes = new Set([
    AssetType.ai,
    AssetType.txt,
    AssetType.docx,
    AssetType.dotx,
    AssetType.indd,
    AssetType.keynoteTheme,
    AssetType.keynote,
    AssetType.pagesTemplate,
    AssetType.pages,
    AssetType.potx,
    AssetType.pptx,
    AssetType.psd,
    AssetType.zip,
    AssetType.obj,
    AssetType.stl,
  ]);
  static textTypes = new Set([
    AssetType.txt,
    AssetType.docx,
    AssetType.dotx,
    AssetType.pagesTemplate,
    AssetType.pages,
    AssetType.zip,
  ]);

  static graphicTypes = new Set([
    AssetType.ai,
    AssetType.indd,
    AssetType.keynoteTheme,
    AssetType.keynote,
    AssetType.potx,
    AssetType.pptx,
    AssetType.psd,
  ]);

  static sketchTypes = new Set([
    AssetType.sketchLayerStyle,
    AssetType.sketchLayer,
    AssetType.sketchSymbol,
    AssetType.sketchTextStyle,
  ]);

  static videoTypes = new Set([AssetType.mov, AssetType.mp4]);

  static motionTypes = new Set([...AssetType.videoTypes, AssetType.lottie, AssetType.gif]);

  static audioTypes = new Set([
    AssetType.wav,
    AssetType.flac,
    AssetType.m4a,
    AssetType.mp3,
    AssetType.ogg,
  ]);

  static modelTypes = new Set([AssetType.obj, AssetType.stl]);

  static displayName(type: string): string {
    return typeDisplayNames[type] || (type || "").replace("_", " ").toLowerCase();
  }
}

const typeDisplayNames = {
  [AssetType.ai]: "Illustrator",
  [AssetType.color]: "Color",
  [AssetType.URL]: "URL",
  [AssetType.docx]: "Word",
  [AssetType.dotx]: "Word template",
  [AssetType.eps]: "EPS",
  [AssetType.flac]: "FLAC",
  [AssetType.gif]: "GIF",
  [AssetType.indd]: "InDesign",
  [AssetType.jpg]: "JPG",
  [AssetType.keynoteTheme]: "Keynote theme",
  [AssetType.keynote]: "Keynote",
  [AssetType.lottie]: "Lottie",
  [AssetType.mov]: "MOV",
  [AssetType.mp3]: "MP3",
  [AssetType.mp4]: "MP4",
  [AssetType.m4a]: "M4A",
  [AssetType.ogg]: "OGG",
  [AssetType.pagesTemplate]: "Pages template",
  [AssetType.pages]: "Pages",
  [AssetType.pdf]: "PDF",
  [AssetType.png]: "PNG",
  [AssetType.potx]: "PowerPoint template",
  [AssetType.pptx]: "PowerPoint",
  [AssetType.psd]: "Photoshop",
  [AssetType.sketchLayerStyle]: "Sketch layer style",
  [AssetType.sketchLayer]: "Sketch layer",
  [AssetType.sketchSymbol]: "Sketch symbol",
  [AssetType.sketchTextStyle]: "Sketch text style",
  [AssetType.svg]: "SVG",
  [AssetType.txt]: "Text File",
  [AssetType.textStyle]: "Font",
  [AssetType.tiff]: "TIFF",
  [AssetType.wav]: "WAV",
  [AssetType.zip]: "ZIP",
  [AssetType.obj]: "OBJ",
  [AssetType.stl]: "STL",
};

export enum ItemType {
  asset = "asset",
  heading = "heading",
  note = "inline_note",
  supportingImage = "supporting_image",
  codeSnippet = "code_snippet",
  guide = "guide",
  link = "link",
  gallery = "gallery",
}

export enum PortalItemType {
  heading = "heading",
  note = "inline_note",
  supportingImage = "supporting_image",
  kit = "kit",
}

export enum PrivacyLevel {
  private = "private",
  password = "password",
  public = "public",
}
